import setupNamespace from '@/app/setupNamespace';
import BookingWidget from '@/app/BookingWidget';
import './vendors/fontawesome';

// Adds WELCMpass namespace to window object
const namespace = setupNamespace('WELCMpass');
namespace.Booking = BookingWidget;
